module.exports = __webpack_public_path__ + "img/galeria-aquario-5.faf20941.jpg";